__turbopack_context__.v({
  "containerScrollable": "scrollable-container-module__qAERCq__containerScrollable",
  "left": "scrollable-container-module__qAERCq__left",
  "right": "scrollable-container-module__qAERCq__right",
  "scrollButton": "scrollable-container-module__qAERCq__scrollButton",
  "scrollableItems": "scrollable-container-module__qAERCq__scrollableItems",
});
